<template>
  <v-container fluid class="ma-0 pa-0">
    <v-col class="ma-0 pa-0" cols="12">
    	<Header title="WebRTC Video Test" />
      <v-col class="ma-0 pa-0" cols="12">
        <v-col class="pa-0" id="main_content_minwidthset" cols="12">
          <v-row class="ma-0 pa-0" align="start">
            <v-col id="main_content" class="ma-0 pa-7" cols="12">
              <!-- <v-col id="video_box" class="pa-0 mb-3" cols="9" align="center">
                <video id="video1" height=500 ref="videoPlayer"
                  style="object-fit: fill;width:100%;height:100%;cursor: default;"
									class="video-js vjs-default-skin vjs-big-play-centered vjs-current-time vjs-control-bar" 
								></video>
              </v-col> -->
							<v-col id="video_box" class="pa-0 mb-2" cols="8" align="center">
								<video id="video0" width=700 height=400
									style="object-fit: fill;width:100%;height:400px;cursor: default;"
									class="video-js vjs-default-skin vjs-big-play-centered vjs-current-time vjs-control-bar">
								</video>
							</v-col>
							<v-col id="video_box" class="pa-0" cols="8" align="center">
								<video id="video1" width=700 height=400
									style="object-fit: fill;width:100%;height:400px;cursor: default;"
									class="video-js vjs-default-skin vjs-big-play-centered vjs-current-time vjs-control-bar">
								</video>
							</v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </v-col>
  </v-container>
</template>

<script>
import mixin from '@/mixin';
import videoPlayerMixin from '@/views/player/mixin/index';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
// import 'videojs-contrib-hls';
// import $ from 'jquery';
import * as controlBar from '../player/buildControlBar';
import AWS from 'aws-sdk';
import { SignalingClient, Role } from 'amazon-kinesis-video-streams-webrtc';
import Header from './components/Header.vue';

// const channelARN = 'arn:aws:kinesisvideo:ap-northeast-2:551344220161:channel/kvs-signal/1681810056482';
const ChannelNameList = ['kvs-signal', 'kvs-signal2'];
const region = 'ap-northeast-2';
const clientId = 'clientId';
const accessKeyId = 'AKIAYAXVNFAAVLBCCGD2';
const secretAccessKey = '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';

export default {
  components: {
		Header
	},
  mixins: [mixin.common, videoPlayerMixin],
  data: () => ({
    player: [],
    playerOptions: {
      controls: true,
      // liveui: true,
      autoplay: 'muted',
			// preload: 'auto',
      controlBar: {
      	pictureInPictureToggle : false,
      	progressControl : false,
      	children: []
      },
    },
    videoDuration: null,
		peerConnection: [],
		signalingClient: [],
		playerCount: 2,
  }),
  mounted() {
		for(let i=0; i<this.playerCount; i++) {
			this.buildVideoPlayer(`video${i}`, ChannelNameList[i], i);
		}
  },
  beforeDestroy() {
		this.player.forEach((player) => {
			if(player != null) {
				player.dispose();
			}
		})
  },
  methods: {
    async buildVideoPlayer(videoTagName, channelName, index) {
			AWS.config.region = region; // Region
			AWS.config.credentials = new AWS.CognitoIdentityCredentials({
				IdentityPoolId: 'ap-northeast-2:82b63a96-7497-488d-b22d-66faf854ebb0',
			});

			const kinesisVideoClient = new AWS.KinesisVideo({
				region,
				accessKeyId,
				secretAccessKey,
				correctClockSkew: true,
			});

			// Get signaling channel ARN
			const describeSignalingChannelResponse = await kinesisVideoClient
				.describeSignalingChannel({
						ChannelName: channelName,
				})
				.promise();
			const channelARN = describeSignalingChannelResponse.ChannelInfo.ChannelARN;
			console.log('[VIEWER] Channel ARN: ', channelARN);

			const getSignalingChannelEndpointResponse = await kinesisVideoClient
				.getSignalingChannelEndpoint({
						ChannelARN: channelARN,
						SingleMasterChannelEndpointConfiguration: {
								Protocols: ['WSS', 'HTTPS'],
								Role: Role.VIEWER,
						},
				})
				.promise();
			const endpointsByProtocol = getSignalingChannelEndpointResponse.ResourceEndpointList.reduce((endpoints, endpoint) => {
					endpoints[endpoint.Protocol] = endpoint.ResourceEndpoint;
					return endpoints;
			}, {});
    	console.log('[VIEWER] Endpoints: ', endpointsByProtocol);

			const kinesisVideoSignalingChannelsClient = new AWS.KinesisVideoSignalingChannels({
				region,
				accessKeyId,
				secretAccessKey,
				endpoint: endpointsByProtocol.HTTPS,
				correctClockSkew: true,
			});
			console.log(endpointsByProtocol.WSS);

			const getIceServerConfigResponse = await kinesisVideoSignalingChannelsClient
					.getIceServerConfig({
							ChannelARN: channelARN,
					})
					.promise();
			const iceServers = [
					// { urls: `stun:stun.kinesisvideo.ap-northeast-2.amazonaws.com:443` }
			];
			getIceServerConfigResponse.IceServerList.forEach(iceServer =>
					iceServers.push({
							urls: iceServer.Uris,
							username: iceServer.Username,
							credential: iceServer.Password,
					}),
			);
    	console.log('[VIEWER] ICE servers: ', iceServers);

			// this.peerConnection = new RTCPeerConnection({ iceServers });
			this.signalingClient[index] = new SignalingClient({
					channelARN,
					channelEndpoint: endpointsByProtocol.WSS,
					clientId,
					role: Role.VIEWER,
					region,
					credentials: {
						accessKeyId,
						secretAccessKey,
					},
					systemClockOffset: kinesisVideoClient.config.systemClockOffset,
			});

			const resolution = { width: { ideal: 1280 }, height: { ideal: 720 } };
			const constraints = {
				video: resolution,
				audio: false,
			};
			const configuration = {
				iceServers,
				// iceTransportPolicy: formValues.forceTURN ? 'relay' : 'all',
				iceTransportPolicy: 'all',
			};
			this.peerConnection[index] = new RTCPeerConnection(configuration);

			this.signalingClient[index].on('open', async () => {
				console.log('[VIEWER] Connected to signaling service');
				
				// Get a stream from the webcam, add it to the peer connection, and display it in the local view.
				// If no video/audio needed, no need to request for the sources. 
				// Otherwise, the browser will throw an error saying that either video or audio has to be enabled.
				// if (formValues.sendVideo || formValues.sendAudio) {
						// try {
						// 		this.localStream = await navigator.mediaDevices.getUserMedia(constraints);
						// 		this.localStream.getTracks().forEach(track => this.peerConnection.addTrack(track, this.localStream));
						// 		this.localView.srcObject = this.localStream;
						// } catch (e) {
						// 		console.error('[VIEWER] Could not find webcam');
						// 		return;
						// }
				// }
				// Create an SDP offer to send to the master
				console.log('[VIEWER] Creating SDP offer');
				await this.peerConnection[index].setLocalDescription(
						await this.peerConnection[index].createOffer({
								offerToReceiveAudio: true,
								offerToReceiveVideo: true,
						}),
				);
				// When trickle ICE is enabled, send the offer now and then send ICE candidates as they are generated. Otherwise wait on the ICE candidates.
				// if (formValues.useTrickleICE) {
						console.log('[VIEWER] Sending SDP offer');
						this.signalingClient[index].sendSdpOffer(this.peerConnection[index].localDescription);
				// }
				console.log('[VIEWER] Generating ICE candidates');
			});

			this.signalingClient[index].on('sdpAnswer', async (answer) => {
					// Add the SDP answer to the peer connection
					console.log('[VIEWER] Received SDP answer');
					await this.peerConnection[index].setRemoteDescription(answer);
			});

			this.signalingClient[index].on('iceCandidate', candidate => {
					// Add the ICE candidate received from the MASTER to the peer connection
					console.log('[VIEWER] Received ICE candidate');
					this.peerConnection[index].addIceCandidate(candidate);
			});

			this.signalingClient[index].on('close', () => {
					console.log('[VIEWER] Disconnected from signaling channel');
			});
			this.signalingClient[index].on('error', error => {
					console.error('[VIEWER] Signaling client error: ', error);
			});

			// Send any ICE candidates to the other peer
			this.peerConnection[index].addEventListener('icecandidate', ({ candidate }) => {
					if (candidate) {
							// console.log('[VIEWER] Generated ICE candidate');

							// When trickle ICE is enabled, send the ICE candidates as they are generated.
							// if (formValues.useTrickleICE) {
									// console.log('[VIEWER] Sending ICE candidate');
									this.signalingClient[index].sendIceCandidate(candidate);
							// }
					} else {
							console.log('[VIEWER] All ICE candidates have been generated');

							// When trickle ICE is disabled, send the offer now that all the ICE candidates have ben generated.
							// if (!formValues.useTrickleICE) {
							//     console.log('[VIEWER] Sending SDP offer');
							//     this.signalingClient.sendSdpOffer(this.peerConnection.localDescription);
							// }
					}
			});

			// As remote tracks are received, add them to the remote view
			this.peerConnection[index].addEventListener('track', event => {
				console.log(event);
				const track = event.track;

				const videoElement = document.getElementById(videoTagName);
				videoElement.autoplay = true;
				videoElement.playsInline = true;
				videoElement.srcObject = new MediaStream([track]);
				videoElement.load();
				videoElement.play();

				this.player[index] = videojs(videoTagName, this.playerOptions);
			});

			console.log('[VIEWER] Starting viewer connection');
			this.signalingClient[index].open();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../player/videoPlayer.scss';
::v-deep .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
	// ControlBar 항상 보이게 하는 옵션
  visibility: visible;
  opacity: 1;
  pointer-events: none;
  transition: visibility 1s, opacity 1s;
}
</style>
